import "./HeaderBalancesheet.scss";
import Avatar from "core/avatar/Avatar";
import Stepper from "./Stepper";
import robot from "assets/images/robot.svg";
import PropTypes from "prop-types";

const HeaderBalancesheet = ({
  user,
  pages,
  getPageIndex,
  setPageIndex,
  pageIndex,
  isExport,
}) => (
  <div className="header-balancesheet">
    <Avatar replace={true} background={robot} size={"medium"} id="robot" />
    <div className="user-info">
      <div className="user-name">
        {user?.first_name} {` `} {user?.last_name}
      </div>
      <div className="user-code">{user?.analytical_code}</div>
      {!isExport && (
        <Stepper
          pages={pages}
          getPageIndex={getPageIndex}
          pageIndex={pageIndex}
          setPageIndex={setPageIndex}
        />
      )}
    </div>
  </div>
);
export default HeaderBalancesheet;

HeaderBalancesheet.propTypes = {
  user: PropTypes.object,
  pages: PropTypes.number,
  getPageIndex: PropTypes.func,
};
